var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"short-answer"},[_c('textarea',{attrs:{"rows":"6","placeholder":"请输入答案","disabled":_vm.disabled},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event.target.value)}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }